@let q = question();
@let v = values();
<h3>{{ q.title }}</h3>
<div [formGroup]="form" class="grid" [ngStyle]="{ gridTemplateColumns: '1fr repeat(' + v.length + ', 90px)' }">
  <div></div>
  @for (value of v; track value.id) {
    <div class="header">{{ value.label }}</div>
  }
  @for (option of q.options; track option.id; let i = $index) {
    <div class="grid-element" [ngClass]="{ 'no-border': i === 0 }">{{ option.label }}</div>
    @for (value of v; track value) {
      <div class="grid-element radio" [ngClass]="{ 'no-border': i === 0 }">
        <input type="radio" [value]="value.id" [formControlName]="option.id" [id]="q.title + value.id + i" />
      </div>
    }
  }
</div>
